import { useSyncExternalStore } from 'react';

import { getTheme, setTheme, subscribeTheme } from './theme';

/** Thème d'affichage choisi (clair, sombre, système) et son setter. */
export const useTheme = () => ({
    theme: useSyncExternalStore(subscribeTheme, getTheme),
    setTheme,
});
